import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../globals';
import { Login } from '../modal/login';
import { pincode } from '../modal/pincode';
import { Observable } from 'rxjs';
import { Otp } from '../modal/Otp';
import { User } from '../modal/user';
import {  HealthCardBackSide } from '../modal/HealthCardBackSide';
import { PromoCode } from '../modal/promocode';
import { PaymentDetails } from '../modal/payment';


@Injectable({
    providedIn: 'root'
})

export class LoginService {
    constructor(private httpclient: HttpClient, private global: Globals) { }

    VerifyLogin(login: Login) {
        return this.httpclient.post(this.global.G_apiUrl + "/login", {
            "emailAddress": login.email,
            "password": login.password
        });
    }

    VerifyMobileNo(mobileno) {
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/checkMobileNo/" + `${mobileno}`, { responseType: 'text' });
    }
    forgotUsername(mobileno) {
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/forgotUsername/" + `${mobileno}`, { responseType: 'text' });
    }

    VerifyName(name, mobileno) {
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/checkName/" + `${name}` + `/${mobileno}`, { responseType: 'text' });
    }

    VerifyPassword(name, mobileno, password, status) {
        var userlLoginDto={
            "name":name,
            "mobileNo":mobileno,
            "password":password,
            "status":status,
            "firebaseToken":this.global.firebaseToken

        }
          return this.httpclient.post(this.global.G_apiUrl + "/userRegistration/checkPassword",userlLoginDto);
        // return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/checkPassword/" + `${name}` + `/${mobileno}` + `/${password}` + `/${status}`);
    }


    VerifyMobileNoGetUser(mobileno) {
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/checkMobileNoGetUser/" + `${mobileno}`);
    }
    passwordChange(password, mobileno,name) {
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/changePassword/" + `${password}` + `/${mobileno}`+ `/${name}`, { responseType: 'text' });
    }
    GenerateOtp(mobileno, name, status) {
        return this.httpclient.get<Otp>(this.global.G_apiUrl + "/userRegistration/GenrateOtp/" + `${mobileno}` + `/${name}` + `/${status}`);
    }
    CheckOtp(optid, otp) {
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/CheckOtp/" + `${optid}` + `/${otp}`, { responseType: 'text' });
    }
    GetPincode(pincode) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get<pincode[]>(this.global.G_apiUrl + "/userRegistration/pincodeSearch/" + `${pincode}`, { headers: headers });
    }

    subscribePlan(planid, userid) {

        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/subscribePlan/" + `${planid}` + `/${userid}`, { responseType: 'text', headers: headers });

    }
    addTranscationalPassword(userid, password) {

        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get<User>(this.global.G_apiUrl + "/userRegistration/addTranscationalPassword/" + `${userid}` + `/${password}`, { headers: headers });

    }
    ChangeLoginPassword(password, mobileno, name) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/changeLoginPassword/" + `${password}` + `/${mobileno}` + `/${name}`, { responseType: 'text', headers: headers });
    }
    ChangePrivacyPassword(password, mobileno, name) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/changePrivacyPassword/" + `${password}` + `/${mobileno}` + `/${name}`, { responseType: 'text', headers: headers });
    }

    checkReferralCode(code) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/checkReferralcode/" + `${code}`, { responseType: 'text', headers: headers });
  }  
changeReferralCode(code) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get<User>(this.global.G_apiUrl + "/userRegistration/changeReferralcode/" + `${this.global.loggedUser.user.user_reg_id}`+`/${code}`, { headers: headers });
    }

    changeMobileno(mobileno) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get<User>(this.global.G_apiUrl + "/userRegistration/changeMobileno/" + `${this.global.loggedUser.user.user_reg_id}` + `/${mobileno}`, { headers: headers });
    }

uploadProfileImg(userObj){
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.post<User>(this.global.G_apiUrl + "/userRegistration/uploadProfileImg" ,userObj,{ headers: headers });
}

updateProfile(userObj){
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.put<User>(this.global.G_apiUrl + "/userRegistration/update",userObj,{ headers: headers });
}  

createHealthCard(userObj){
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.post<User>(this.global.G_apiUrl + "/userRegistration/createHealthCard",userObj,{ headers: headers });
} 

createHealthCardMobileView(userObj){
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.post<User>(this.global.G_apiUrl + "/userRegistration/createHealthCardMobileView",userObj,{ headers: headers });
} 



getUserById(userid){
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.get<User>(this.global.G_apiUrl + "/userRegistration/getUserInfoById/"+userid,{ headers: headers });
} 

getUserPlanInfoById(userid){
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/getUserPlanInfoById/"+userid,{ headers: headers });
} 


FindByNameAndMobileno(name, mobileno) {
    let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.get<User>(this.global.G_apiUrl + "/userRegistration/findByNameAndMobileno/" + `${name}` + `/${mobileno}`,{ headers: headers });
}


userUpdatePlanWithPromoCode(userid,promocodeid){
    return this.httpclient.get<PaymentDetails>(this.global.G_apiUrl + "/userRegistration/updateUserPlanWithPromoCode/" + `${userid}` + `/${promocodeid}`);
}
userUpdatePlanWithPromoCodeAmountZero(userid,promocodeid){
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/updateUserPlanWithPromoCodeAmountZero/" + `${userid}` + `/${promocodeid}`,{ responseType: 'text', headers: headers });
}
userUpdatePlanWithOutPromoCode(updatePlanRequestDto){
    return this.httpclient.post<PaymentDetails>(this.global.G_apiUrl + "/userRegistration/updateUserPlanWithOutPromoCode" ,updatePlanRequestDto);
}


userGetHealthCard(userHealthRequestDto){
    return this.httpclient.post<PaymentDetails>(this.global.G_apiUrl + "/userRegistration/userHealthCardCharges/",userHealthRequestDto);

}
deleteUser(userid){
    return this.httpclient.delete(this.global.G_apiUrl + "/userRegistration/deleteuser/" + `${userid}`,{ responseType: 'text'});
}
findMultipleUserById(usersid){
    
    return this.httpclient.post<User>(this.global.G_apiUrl + "/userRegistration/findMultipleUserById", usersid); 
  }

}



